import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5c0a8b11&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Andre\\OneDrive\\Desktop\\Documents\\GitHub\\vue-covid-tracker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0a8b11"]])

export default __exports__